export default __webpack_public_path__ + "static/media/grayBig.6c1fae52.svg";